<template>
    <div>
        <div class="mb-md-5">
            <template v-if="header">
                <h4 class="mt-0 filter-subtitle">{{variation.name}}</h4>
                <hr class="sidebar-categories-spacer">
            </template>
            <div class="form-check mb-3" v-for="item in variation.options" :key="item.id">
                <input class="form-check-input" type="checkbox" :value="variation.id + '_' + item.id" :id="'filter_variation' + item.id" v-model="filter_variations" @change="change_filter_variation($event)">
                <label class="form-check-label filter-option-name" :for="'filter_variation' + item.id">
                    {{ item.name }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    import ecommerce_products_filters from "~/mixins/ecommerce_products_filters";

    export default {
        props: {
            variation: {
                default: () => {}
            },
            header: {
                default: true
            }
        },
        mixins: [
            ecommerce_products_filters
        ]
    }
</script>
